import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Seo from '@components/Seo'
import Branch from '@containers/Branch'

const BranchPage = ({ data }) => {
  const branch = R.pathOr(null, ['contentfulPage', 'template', '0'], data)
  const metaTitle = R.pathOr('BSS', ['contentfulPage', 'metaTitle'], data)
  const metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data)
  const canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data)

  return (
    <Fragment>
      <Seo
        title={metaTitle}
        description={metaDescription}
        canonicalUrl={canonicalUrl}
      />

      {branch && <Branch branch={branch} />}
    </Fragment>
  )
}

BranchPage.propTypes = {
  data: PropTypes.shape({
    contentfulPage: PropTypes.shape({
      metaTitle: PropTypes.string,
      metaDescription: PropTypes.string,
      template: PropTypes.array
    })
  }).isRequired
}

export const query = graphql`
  query branchQuery($slug: String) {
    contentfulPage(slug: { eq: $slug }) {
      metaTitle
      canonicalUrl
      metaDescription
      template {
        ... on ContentfulBranchTemplate {
          title
          placeId
          address
          phone
          email
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
      }
    }
  }
`

export default BranchPage



// WEBPACK FOOTER //
// ./src/templates/branch.js